export const FcCodeFlg = [
  { label: 'FCコードを設定する', value: '1' },
  { label: 'FCコードを設定しない', value: '2' },
];
